import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "pogocard__states" }
const _hoisted_3 = { class: "pogocard__content" }
const _hoisted_4 = { class: "pogocard__title" }
const _hoisted_5 = { class: "pogocard__title" }

import { Pokemon, PokemonId } from '@/types/pokemon'
import { PokedexEntry } from '@/types/pokedex'
import { computed } from 'vue'
import { pokedexIcons } from '@/types/pokedex'


export default /*#__PURE__*/_defineComponent({
  __name: 'PogoCard',
  props: {
    pokemon: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as {
  pokemon: {
    id: PokemonId
    data: Pokemon
    entry: PokedexEntry
    visible: boolean
  }
}



const styles = computed(() => {
  let r: { [key: string]: string } = {}
  if (props.pokemon.data.type.length === 1) {
    r['--background'] = `var(--${props.pokemon.data.type[0]})`
  }
  if (props.pokemon.data.type.length === 2) {
    const s = `var(--${props.pokemon.data.type[0]})`
    const e = `var(--${props.pokemon.data.type[1]})`
    r['--background'] = `linear-gradient(to right, ${s} 50%, ${e} 50%)`
  }
  return r
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pogocard", { 'pogocard--visible': __props.pokemon.visible }])
  }, [
    _createElementVNode("div", {
      class: "pogocard__img",
      style: _normalizeStyle(_unref(styles))
    }, [
      (__props.pokemon.visible)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.pokemon.data.img
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pokemon.entry.genre, (genre, key) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pokedexIcons)[key]), {
            class: _normalizeClass(["pogocard__state", { 'pogocard__state--registered': genre }]),
            key: key,
            onClick: ($event: any) => (emit('update', {
            type: 'genre',
            prop: key,
            value: !genre
          }))
          }, null, 8, ["class", "onClick"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pokemon.entry.state, (state, key) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pokedexIcons)[key]), {
            class: _normalizeClass(["pogocard__state", { 'pogocard__state--registered': state }]),
            key: key,
            onClick: ($event: any) => (emit('update', {
            type: 'state',
            prop: key,
            value: !state
          }))
          }, null, 8, ["class", "onClick"]))
        }), 128))
      ])
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.pokemon.id), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.pokemon.data.name.fr), 1)
    ])
  ], 2))
}
}

})